










































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import CalendarSearch from "@/components/calendar/CalendarSearch.vue";
import CalendarView from "@/components/schedule/Calendar.vue";
import ListView from "@/components/calendar/CalendarList.vue";
import CalendarEditor from "@/components/calendar/CalendarEditor.vue";
//import ApptLog from "@/components/schedule/Log.vue";
import Pager from "@/components/Pager.vue";
import { ScheduleView } from "@/store/modules/enums";
import { CalendarFilter } from "@/store/modules/types";

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    CalendarSearch,
    CalendarView,
    ListView,
    CalendarEditor,
    Pager
    //ApptLog,
  },
  computed: {
    ...mapState("schedule", ["view", "list"]),
  },
})
export default class Calendars extends Vue {
  filter!:CalendarFilter;
  view!: ScheduleView;

   pageRows: Array<any> = [];
  totalRows: number = 0;

  list!: any;
  selected: any | null = null;
  @Watch("list.filter", { deep: true })
  onFilterChanged() {
    this.getAppts();
  }

  defaultFilter(): CalendarFilter {
    return {
       name: "",
  active:  null,
  orderBy: "",
  pageNumber: 1,
  rowsPerPage: 25

    }
    
    }
  async getAppts() {
    this.$store.commit("main/SET_LOADING", true);
    try {
     this.list.calendars = await this.$store.dispatch("schedule/getCalendarList",this.filter);
     this.totalRows = this.list.calendars.length;
     /*this.totalRows = data.totalRows;
      this.pageRows = data.pageRows;*/
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  editCalendar(calendar: any) {
    this.selected = calendar;
    this.$modal.show("calendar-editor");
  }
  showLog(appt: any) {
    this.selected = appt;
    this.$modal.show("appt-log");
  }
  get ScheduleView() {
    return ScheduleView;
  }
  mounted() {
   // if (!this.list.totalRows) 

   this.filter = this.defaultFilter();
    this.getAppts();
  }
}
